
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cookiepolicy",
      function () {
        return require("private-next-pages/cookiepolicy/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cookiepolicy"])
      });
    }
  